export default (duration, drawFunction, onComplete = () => {}) => new Promise((resolve) => {
  const start = performance.now();

  const animationLoop = (time) => {
    let timeFraction = (time - start) / duration;

    if (timeFraction > 1) {
      timeFraction = 1;
      resolve();
    }

    drawFunction(timeFraction);

    if (timeFraction < 1) {
      requestAnimationFrame(animationLoop);
    }
  };

  requestAnimationFrame(animationLoop);
}).then(onComplete);
